<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="imgstyle">
      <div v-if="showFile()" class="music-container" :style="musicFrameStyle">
        <el-tooltip :content="tooltipForPlay" placement="top-start">
          <i class="el-icon-download el-icon-action" @click="handleDownload" />
        </el-tooltip>
        <el-tooltip
          :content="tooltipForDelete"
          placement="top-start"
          v-if="isedite && (maxLength !== 1 || token)"
        >
          <i class="el-icon-delete el-icon-action" @click="handleDelete" />
        </el-tooltip>
      </div>
      <el-tooltip
        v-else
        popper-class="image-tip"
        :disabled="disabledTooltip() || !isedite"
        :content="tooltip"
        placement="top-start"
      >
        <el-upload
          class="upload-btn"
          :style="uploadStyle"
          :action="uploadAction"
          :disabled="!isedite"
          :show-file-list="false"
          :accept="supporttypes()"
          :on-success="handleUploadSuccess"
          :before-upload="handleBeforeUpload"
        >
          <div class="icon-wrap-container" :style="uploadStyle">
            <i class="el-icon-loading uploader-icon" v-if="fileloading" />
            <i class="el-icon-plus uploader-icon" v-else />
          </div>
        </el-upload>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Validator from '../../utils/validator'
import * as storage from '@/utils/storage'

export default {
  name: 'jtFile',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    src: {
      type: String,
      default: '',
    },
    musicName: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '150px',
    },
    height: {
      type: String,
      default: '40px',
    },
    uploadAction: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    supportTypes: {
      type: Array,
      default: () => [''],
    },
    supportSize: {
      type: Array,
      default: [5],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
    types: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      imgstyle: {
        width: window.innerWidth > 768 ? '500px' : '100%',
      },
      musicFrameStyle: {
        width: window.innerWidth > 768 ? this.width: '100%',
        height: this.height,
      },
      uploadStyle: {
        width: window.innerWidth > 768 ? this.width: '100%',
        height: this.height,
        textAlign: 'center',
      },
      tooltipForPlay: this.$t('file.PLAY'),
      tooltipForDelete: this.$t('file.DELETE'),
      playing: false,
      audio: null,
      fileloading: false,
      token: storage.getItem('token'),
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    supporttypes() {
      let types = '*'
      if (this.types == 'xlsfile') {
        types = '.xlsx,.xls'
      } else if (this.types == 'pdffile') {
        types = '.pdf'
      } else if (this.types == 'docfile') {
        types = '.doc,.docx'
      }
      return types
    },
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    showFile() {
      return !_.isEmpty(this.src)
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },

    handleDownload() {
      const link = document.createElement('a')
      link.href = this.src // 文件地址
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleDelete() {
      const msg = this.$t('image.CONFIRM_FOR_DELETE')
      const title = this.$t('global.TIPS')
      this.$confirm(msg, title)
        .then(() => {
          this.audio = null
          this.$emit('delete')
        })
        .catch(() => {})
    },
    handleUploadSuccess(response, file, fileList) {
      this.$emit('success', response.payload)
      this.fileloading = false
    },
    async handleBeforeUpload(file) {
      try {
        this._validate(file)
        this.fileloading = true
        return true
      } catch (err) {
        const title = this.$t('global.ERROR')
        await this.$alert(err.message, title, {
          type: 'error',
          showClose: false,
        })

        throw err
      }
    },
    _validate(file) {
      let errMsg = this.$t('file.SUPPORT_FILE_TYPE', {
        fileType: _.join(this.supportTypes),
      })
      Validator.isSupportFileType(file.type, this.supportTypes, errMsg)

      let errMsg1 = this.$t('file.SUPPORT_FILE_SIZE', {
        fileSize:
          this.supportSize.length === 2
            ? this.supportSize[1] / 1024 / 1024
            : this.supportSize[0] / 1024 / 1024,
      })
      let errMsg2 = this.$t('file.MIN_FILE_SIZE', {
        fileSize: this.supportSize[0] / 1024 / 1024,
      })
      Validator.isSupportFileSize(file.size, this.supportSize, errMsg1, errMsg2)
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.music-container {
  border: 1px dashed #333;
  padding: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 22px;
}

.music-name {
  width: 70%;
}

.el-icon-action {
  color: black;
  margin-left: 5px;
  cursor: pointer;
}

.upload-btn {
  border: 1px dashed #333;
}

.icon-wrap-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.uploader-icon {
  font-size: 28px;
  color: #333;
  cursor: pointer;
}

.image-tip {
  max-width: 200px;
}

</style>
